import { ApiKeys } from '@app/constants/api-keys'
import { IOrganizationSchedule } from '@app/interfaces/organization/organization-schedule'
import { resolveTParams } from '@app/utils/resolve-params/resolve-params'
import localforage from 'localforage'
import { emptyOrganizationApi } from '.'
import { IRtkResponse } from '../../types'

export const organizationScheduleApi = emptyOrganizationApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (build) => ({
    getOrganizationSchedules: build.query<
      IRtkResponse<IOrganizationSchedule[]>,
      URLSearchParams | string
    >({
      query: (args = '') => ({
        url: 'dictionary/api/v1/organization-schedule',
        method: 'get',
        params: {
          ...resolveTParams(args),
        },
      }),
      transformResponse: (response: IOrganizationSchedule[], meta) => {
        return { response, meta }
      },
      providesTags: (data) =>
        data
          ? [
              ...data.response.map(({ id }) => ({
                type: ApiKeys.organizationSchedule,
                id,
              })),
              { type: ApiKeys.organizationSchedule, id: 'LIST' },
            ]
          : [{ type: ApiKeys.organizationSchedule, id: 'LIST' }],
      async onQueryStarted(args, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          localforage.setItem(ApiKeys.organizationSchedule, data?.response)
        } catch (e) {
          console.error(e)
        }
      },
    }),
    getOrganizationSchedule: build.query<IOrganizationSchedule, number>({
      query: (id) => ({
        url: `dictionary/api/v1/organization-schedule/${id}`,
        method: 'get',
      }),
      providesTags: (result, error, id) => [
        { type: ApiKeys.organizationSchedule, id },
      ],
    }),
  }),
})

export const {
  useGetOrganizationScheduleQuery,
  useGetOrganizationSchedulesQuery,
} = organizationScheduleApi
